import { inject, Injectable } from '@angular/core';
import { EntityAction, SystemEntity } from '@wdx/shared/utils';
import {
    ActivityfileIdActionsApiService,
    ActivityIdActionsApiService,
    AdviserIdActionsApiService,
    AmlreportIdActionsApiService,
    AmlriskIdActionsApiService,
    AnswerIdActionsApiService,
    AnswertypeIdActionsApiService,
    AppendixappIdActionsApiService,
    AppendixcalculationIdActionsApiService,
    AppendixlayoutIdActionsApiService,
    AppendixschemaIdActionsApiService,
    AppointmentIdActionsApiService,
    ArticledistributionIdActionsApiService,
    ArticleIdActionsApiService,
    AuditeventIdActionsApiService,
    BankaccountIdActionsApiService,
    BenchmarkIdActionsApiService,
    BlockIdActionsApiService,
    CampaignIdActionsApiService,
    CampaignresponseIdActionsApiService,
    CaseIdActionsApiService,
    ChannelIdActionsApiService,
    ClientIdActionsApiService,
    ClientproductallocationIdActionsApiService,
    ClientproductfeeIdActionsApiService,
    ClientproductIdActionsApiService,
    ClientproductrelationshipIdActionsApiService,
    ConstructIdActionsApiService,
    CountryassociationIdActionsApiService,
    CountryIdActionsApiService,
    CurrencyIdActionsApiService,
    DocumentIdActionsApiService,
    DocumentrequirementIdActionsApiService,
    DocumentrequirementtypeIdActionsApiService,
    DocumenttemplateIdActionsApiService,
    DocumenttypeIdActionsApiService,
    EdsmessagebatchIdActionsApiService,
    EdsmessageIdActionsApiService,
    ElectronicaddressIdActionsApiService,
    ElectronicbankingaddressIdActionsApiService,
    EmailIdActionsApiService,
    EmploymenthistoryIdActionsApiService,
    EngagementIdActionsApiService,
    EntityattributemetadataIdActionsApiService,
    EntitymetadataIdActionsApiService,
    EnvelopeIdActionsApiService,
    EventIdActionsApiService,
    EventparticipationIdActionsApiService,
    ExportIdActionsApiService,
    ExternalbankaccountIdActionsApiService,
    ExternaltaskIdActionsApiService,
    ExternaluserIdActionsApiService,
    FavouriteIdActionsApiService,
    FeestructureIdActionsApiService,
    FinancialrecordsubtypeIdActionsApiService,
    FormfieldmetadataIdActionsApiService,
    FormfunctionmetadataIdActionsApiService,
    FormmetadataIdActionsApiService,
    GoalIdActionsApiService,
    GoaltypeIdActionsApiService,
    HistoryIdActionsApiService,
    IdentitycheckIdActionsApiService,
    IdentitycheckresultIdActionsApiService,
    ImportIdActionsApiService,
    ImportlogIdActionsApiService,
    InsiderhistoryIdActionsApiService,
    InsuranceaccountIdActionsApiService,
    IntermediaryIdActionsApiService,
    InvestmentaccountIdActionsApiService,
    JobIdActionsApiService,
    KycreportIdActionsApiService,
    LeadIdActionsApiService,
    LendingaccountIdActionsApiService,
    LetterIdActionsApiService,
    ListIdActionsApiService,
    ListmemberIdActionsApiService,
    ListtypeIdActionsApiService,
    MailinginstructionIdActionsApiService,
    MandategroupIdActionsApiService,
    MandateIdActionsApiService,
    MessageIdActionsApiService,
    NationalidentifierIdActionsApiService,
    NoteIdActionsApiService,
    NotificationIdActionsApiService,
    NudgeIdActionsApiService,
    NudgetypeIdActionsApiService,
    ObjectiveIdActionsApiService,
    OpportunityIdActionsApiService,
    OpportunityproductIdActionsApiService,
    OrganisationIdActionsApiService,
    PartyIdActionsApiService,
    PartyroleIdActionsApiService,
    PartysystemconnectionIdActionsApiService,
    PendingchangeIdActionsApiService,
    PensionaccountIdActionsApiService,
    PersonIdActionsApiService,
    PhoneaddressIdActionsApiService,
    PhonecallIdActionsApiService,
    PortfolioIdActionsApiService,
    PostaladdressIdActionsApiService,
    ProductcategoryIdActionsApiService,
    ProductcriteriaIdActionsApiService,
    ProductcriteriatypeIdActionsApiService,
    ProductfeeIdActionsApiService,
    ProductgroupIdActionsApiService,
    ProductIdActionsApiService,
    ProductlineassociationIdActionsApiService,
    ProductlineIdActionsApiService,
    ProductproviderIdActionsApiService,
    ProductrecommendationIdActionsApiService,
    ProducttypeIdActionsApiService,
    ProjectIdActionsApiService,
    ProjecttemplateIdActionsApiService,
    ProjecttemplatetaskIdActionsApiService,
    ProtectedfieldgroupIdActionsApiService,
    ProtectionaccountIdActionsApiService,
    QistatusIdActionsApiService,
    QueueitemIdActionsApiService,
    QueuestatusIdActionsApiService,
    RegionIdActionsApiService,
    RelationshipIdActionsApiService,
    ReportIdActionsApiService,
    ReportrequestIdActionsApiService,
    RisklevelIdActionsApiService,
    RiskprofileanswerIdActionsApiService,
    RiskprofilequestionIdActionsApiService,
    RolesubtypeIdActionsApiService,
    RoletypeIdActionsApiService,
    SalutationIdActionsApiService,
    ScheduledjobIdActionsApiService,
    ServicetypeIdActionsApiService,
    SessionIdActionsApiService,
    SignatoryIdActionsApiService,
    SocialaddressIdActionsApiService,
    SystemlogIdActionsApiService,
    TagIdActionsApiService,
    TaskIdActionsApiService,
    TeamIdActionsApiService,
    TimebookingIdActionsApiService,
    TransactionevidenceIdActionsApiService,
    TransactionIdActionsApiService,
    UnitgroupIdActionsApiService,
    UnitIdActionsApiService,
    UserIdActionsApiService,
    WealthmanagementaccountIdActionsApiService,
    WebhookIdActionsApiService,
    WebhooklogIdActionsApiService,
    WorkflowIdActionsApiService,
    WorkflowlogIdActionsApiService,
    WorkitemIdActionsApiService,
} from '../services';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class EntityIdActionsService {
    private noApiServiceFallback = (systemEntity: SystemEntity) => ({
        get: (id: string) => {
            console.error(
                `${systemEntity} does not have an operation API service. Returning empty EntityActions.`,
            );
            return of([] as EntityAction[]);
        },
    });

    private serviceMap: Record<
        SystemEntity,
        {
            get: (id: string) => Observable<EntityAction[]>;
        }
    > = {
        [SystemEntity.Activity]: inject(ActivityIdActionsApiService),
        [SystemEntity.ActivityFile]: inject(ActivityfileIdActionsApiService),
        [SystemEntity.ActivityParty]: this.noApiServiceFallback(
            SystemEntity.ActivityParty,
        ),
        [SystemEntity.Adviser]: inject(AdviserIdActionsApiService),
        [SystemEntity.AmlReport]: inject(AmlreportIdActionsApiService),
        [SystemEntity.AmlRisk]: inject(AmlriskIdActionsApiService),
        [SystemEntity.Answer]: inject(AnswerIdActionsApiService),
        [SystemEntity.AnswerType]: inject(AnswertypeIdActionsApiService),
        [SystemEntity.AppStatus]: this.noApiServiceFallback(
            SystemEntity.AppStatus,
        ),
        [SystemEntity.AppendixApp]: inject(AppendixappIdActionsApiService),
        [SystemEntity.AppendixCalculation]: inject(
            AppendixcalculationIdActionsApiService,
        ),
        [SystemEntity.AppendixEntry]: this.noApiServiceFallback(
            SystemEntity.AppendixEntry,
        ),
        [SystemEntity.AppendixLayout]: inject(
            AppendixlayoutIdActionsApiService,
        ),
        [SystemEntity.AppendixSchema]: inject(
            AppendixschemaIdActionsApiService,
        ),
        [SystemEntity.Appointment]: inject(AppointmentIdActionsApiService),
        [SystemEntity.Article]: inject(ArticleIdActionsApiService),
        [SystemEntity.ArticleDistribution]: inject(
            ArticledistributionIdActionsApiService,
        ),
        [SystemEntity.AuditEvent]: inject(AuditeventIdActionsApiService),
        [SystemEntity.BankAccount]: inject(BankaccountIdActionsApiService),
        [SystemEntity.Benchmark]: inject(BenchmarkIdActionsApiService),
        [SystemEntity.Block]: inject(BlockIdActionsApiService),
        [SystemEntity.Campaign]: inject(CampaignIdActionsApiService),
        [SystemEntity.CampaignResponse]: inject(
            CampaignresponseIdActionsApiService,
        ),
        [SystemEntity.Case]: inject(CaseIdActionsApiService),
        [SystemEntity.CaseTeamMember]: this.noApiServiceFallback(
            SystemEntity.CaseTeamMember,
        ),
        [SystemEntity.CaseType]: this.noApiServiceFallback(
            SystemEntity.CaseType,
        ),
        [SystemEntity.Channel]: inject(ChannelIdActionsApiService),
        [SystemEntity.Client]: inject(ClientIdActionsApiService),
        [SystemEntity.ClientProduct]: inject(ClientproductIdActionsApiService),
        [SystemEntity.ClientProductAccess]: this.noApiServiceFallback(
            SystemEntity.ClientProductAccess,
        ),
        [SystemEntity.ClientProductAllocation]: inject(
            ClientproductallocationIdActionsApiService,
        ),
        [SystemEntity.ClientProductAssociation]: this.noApiServiceFallback(
            SystemEntity.ClientProductAssociation,
        ),
        [SystemEntity.ClientProductFee]: inject(
            ClientproductfeeIdActionsApiService,
        ),
        [SystemEntity.ClientProductGroup]: this.noApiServiceFallback(
            SystemEntity.ClientProductGroup,
        ),
        [SystemEntity.ClientProductRelationship]: inject(
            ClientproductrelationshipIdActionsApiService,
        ),
        [SystemEntity.Comment]: this.noApiServiceFallback(SystemEntity.Comment),
        [SystemEntity.Construct]: inject(ConstructIdActionsApiService),
        [SystemEntity.ContactPoint]: this.noApiServiceFallback(
            SystemEntity.ContactPoint,
        ),
        [SystemEntity.Country]: inject(CountryIdActionsApiService),
        [SystemEntity.CountryAssociation]: inject(
            CountryassociationIdActionsApiService,
        ),
        [SystemEntity.CreditAccount]: this.noApiServiceFallback(
            SystemEntity.CreditAccount,
        ),
        [SystemEntity.Currency]: inject(CurrencyIdActionsApiService),
        [SystemEntity.DataLock]: this.noApiServiceFallback(
            SystemEntity.DataLock,
        ),
        [SystemEntity.DmsDocument]: this.noApiServiceFallback(
            SystemEntity.DmsDocument,
        ),
        [SystemEntity.Document]: inject(DocumentIdActionsApiService),
        [SystemEntity.DocumentAssociation]: this.noApiServiceFallback(
            SystemEntity.DocumentAssociation,
        ),
        [SystemEntity.DocumentRequirement]: inject(
            DocumentrequirementIdActionsApiService,
        ),
        [SystemEntity.DocumentRequirementType]: inject(
            DocumentrequirementtypeIdActionsApiService,
        ),
        [SystemEntity.DocumentTemplate]: inject(
            DocumenttemplateIdActionsApiService,
        ),
        [SystemEntity.DocumentType]: inject(DocumenttypeIdActionsApiService),
        [SystemEntity.EdsMessage]: inject(EdsmessageIdActionsApiService),
        [SystemEntity.EdsMessageBatch]: inject(
            EdsmessagebatchIdActionsApiService,
        ),
        [SystemEntity.ElectronicAddress]: inject(
            ElectronicaddressIdActionsApiService,
        ),
        [SystemEntity.ElectronicBankingAddress]: inject(
            ElectronicbankingaddressIdActionsApiService,
        ),
        [SystemEntity.Email]: inject(EmailIdActionsApiService),
        [SystemEntity.EmploymentHistory]: inject(
            EmploymenthistoryIdActionsApiService,
        ),
        [SystemEntity.Engagement]: inject(EngagementIdActionsApiService),
        [SystemEntity.EntityAttributeMetadata]: inject(
            EntityattributemetadataIdActionsApiService,
        ),
        [SystemEntity.EntityMetadata]: inject(
            EntitymetadataIdActionsApiService,
        ),
        [SystemEntity.Envelope]: inject(EnvelopeIdActionsApiService),
        [SystemEntity.Event]: inject(EventIdActionsApiService),
        [SystemEntity.EventParticipation]: inject(
            EventparticipationIdActionsApiService,
        ),
        [SystemEntity.Export]: inject(ExportIdActionsApiService),
        [SystemEntity.ExternalBankAccount]: inject(
            ExternalbankaccountIdActionsApiService,
        ),
        [SystemEntity.ExternalBankAccountAssociation]:
            this.noApiServiceFallback(
                SystemEntity.ExternalBankAccountAssociation,
            ),
        [SystemEntity.ExternalTask]: inject(ExternaltaskIdActionsApiService),
        [SystemEntity.ExternalUser]: inject(ExternaluserIdActionsApiService),
        [SystemEntity.Favourite]: inject(FavouriteIdActionsApiService),
        [SystemEntity.FeeStructure]: inject(FeestructureIdActionsApiService),
        [SystemEntity.Feed]: this.noApiServiceFallback(SystemEntity.Feed),
        [SystemEntity.FeedNudge]: this.noApiServiceFallback(
            SystemEntity.FeedNudge,
        ),
        [SystemEntity.FileIndex]: this.noApiServiceFallback(
            SystemEntity.FileIndex,
        ),
        [SystemEntity.FinancialRecord]: this.noApiServiceFallback(
            SystemEntity.FinancialRecord,
        ),
        [SystemEntity.FinancialRecordSubType]: inject(
            FinancialrecordsubtypeIdActionsApiService,
        ),
        [SystemEntity.FormData]: this.noApiServiceFallback(
            SystemEntity.FormData,
        ),
        [SystemEntity.FormFieldMetadata]: inject(
            FormfieldmetadataIdActionsApiService,
        ),
        [SystemEntity.FormFunctionMetadata]: inject(
            FormfunctionmetadataIdActionsApiService,
        ),
        [SystemEntity.FormMetadata]: inject(FormmetadataIdActionsApiService),
        [SystemEntity.GeneratedDocument]: this.noApiServiceFallback(
            SystemEntity.GeneratedDocument,
        ),
        [SystemEntity.Goal]: inject(GoalIdActionsApiService),
        [SystemEntity.GoalType]: inject(GoaltypeIdActionsApiService),
        [SystemEntity.History]: inject(HistoryIdActionsApiService),
        [SystemEntity.IdentityCheck]: inject(IdentitycheckIdActionsApiService),
        [SystemEntity.IdentityCheckResult]: inject(
            IdentitycheckresultIdActionsApiService,
        ),
        [SystemEntity.IdentityMap]: this.noApiServiceFallback(
            SystemEntity.IdentityMap,
        ),
        [SystemEntity.Import]: inject(ImportIdActionsApiService),
        [SystemEntity.ImportLog]: inject(ImportlogIdActionsApiService),
        [SystemEntity.InsiderHistory]: inject(
            InsiderhistoryIdActionsApiService,
        ),
        [SystemEntity.InsuranceAccount]: inject(
            InsuranceaccountIdActionsApiService,
        ),
        [SystemEntity.Intermediary]: inject(IntermediaryIdActionsApiService),
        [SystemEntity.InvestmentAccount]: inject(
            InvestmentaccountIdActionsApiService,
        ),
        [SystemEntity.Job]: inject(JobIdActionsApiService),
        [SystemEntity.KanbanStage]: this.noApiServiceFallback(
            SystemEntity.KanbanStage,
        ),
        [SystemEntity.KanbanType]: this.noApiServiceFallback(
            SystemEntity.KanbanType,
        ),
        [SystemEntity.KycReport]: inject(KycreportIdActionsApiService),
        [SystemEntity.Lead]: inject(LeadIdActionsApiService),
        [SystemEntity.LendingAccount]: inject(
            LendingaccountIdActionsApiService,
        ),
        [SystemEntity.Letter]: inject(LetterIdActionsApiService),
        [SystemEntity.List]: inject(ListIdActionsApiService),
        [SystemEntity.ListMember]: inject(ListmemberIdActionsApiService),
        [SystemEntity.ListType]: inject(ListtypeIdActionsApiService),
        [SystemEntity.MailingInstruction]: inject(
            MailinginstructionIdActionsApiService,
        ),
        [SystemEntity.Mandate]: inject(MandateIdActionsApiService),
        [SystemEntity.MandateGroup]: inject(MandategroupIdActionsApiService),
        [SystemEntity.Message]: inject(MessageIdActionsApiService),
        [SystemEntity.NationalIdentifier]: inject(
            NationalidentifierIdActionsApiService,
        ),
        [SystemEntity.Note]: inject(NoteIdActionsApiService),
        [SystemEntity.Notification]: inject(NotificationIdActionsApiService),
        [SystemEntity.Nudge]: inject(NudgeIdActionsApiService),
        [SystemEntity.NudgeLog]: this.noApiServiceFallback(
            SystemEntity.NudgeLog,
        ),
        [SystemEntity.NudgeType]: inject(NudgetypeIdActionsApiService),
        [SystemEntity.Objective]: inject(ObjectiveIdActionsApiService),
        [SystemEntity.Opportunity]: inject(OpportunityIdActionsApiService),
        [SystemEntity.OpportunityProduct]: inject(
            OpportunityproductIdActionsApiService,
        ),
        [SystemEntity.OpportunityTeamMember]: this.noApiServiceFallback(
            SystemEntity.OpportunityTeamMember,
        ),
        [SystemEntity.Organisation]: inject(OrganisationIdActionsApiService),
        [SystemEntity.Party]: inject(PartyIdActionsApiService),
        [SystemEntity.PartyRole]: inject(PartyroleIdActionsApiService),
        [SystemEntity.PartyRoleAccess]: this.noApiServiceFallback(
            SystemEntity.PartyRoleAccess,
        ),
        [SystemEntity.PartySystemConnection]: inject(
            PartysystemconnectionIdActionsApiService,
        ),
        [SystemEntity.PendingChange]: inject(PendingchangeIdActionsApiService),
        [SystemEntity.PensionAccount]: inject(
            PensionaccountIdActionsApiService,
        ),
        [SystemEntity.Person]: inject(PersonIdActionsApiService),
        [SystemEntity.PhoneAddress]: inject(PhoneaddressIdActionsApiService),
        [SystemEntity.PhoneCall]: inject(PhonecallIdActionsApiService),
        [SystemEntity.Portfolio]: inject(PortfolioIdActionsApiService),
        [SystemEntity.PostalAddress]: inject(PostaladdressIdActionsApiService),
        [SystemEntity.PotentialDuplicate]: this.noApiServiceFallback(
            SystemEntity.PotentialDuplicate,
        ),
        [SystemEntity.Process]: this.noApiServiceFallback(SystemEntity.Process),
        [SystemEntity.ProcessType]: this.noApiServiceFallback(
            SystemEntity.ProcessType,
        ),
        [SystemEntity.Product]: inject(ProductIdActionsApiService),
        [SystemEntity.ProductCategory]: inject(
            ProductcategoryIdActionsApiService,
        ),
        [SystemEntity.ProductCriteria]: inject(
            ProductcriteriaIdActionsApiService,
        ),
        [SystemEntity.ProductCriteriaType]: inject(
            ProductcriteriatypeIdActionsApiService,
        ),
        [SystemEntity.ProductFee]: inject(ProductfeeIdActionsApiService),
        [SystemEntity.ProductFinancialLink]: this.noApiServiceFallback(
            SystemEntity.ProductFinancialLink,
        ),
        [SystemEntity.ProductGroup]: inject(ProductgroupIdActionsApiService),
        [SystemEntity.ProductLine]: inject(ProductlineIdActionsApiService),
        [SystemEntity.ProductLineAssociation]: inject(
            ProductlineassociationIdActionsApiService,
        ),
        [SystemEntity.ProductProvider]: inject(
            ProductproviderIdActionsApiService,
        ),
        [SystemEntity.ProductRecommendation]: inject(
            ProductrecommendationIdActionsApiService,
        ),
        [SystemEntity.ProductType]: inject(ProducttypeIdActionsApiService),
        [SystemEntity.Project]: inject(ProjectIdActionsApiService),
        [SystemEntity.ProjectTemplate]: inject(
            ProjecttemplateIdActionsApiService,
        ),
        [SystemEntity.ProjectTemplateTask]: inject(
            ProjecttemplatetaskIdActionsApiService,
        ),
        [SystemEntity.ProtectedFieldGroup]: inject(
            ProtectedfieldgroupIdActionsApiService,
        ),
        [SystemEntity.ProtectionAccount]: inject(
            ProtectionaccountIdActionsApiService,
        ),
        [SystemEntity.QiStatus]: inject(QistatusIdActionsApiService),
        [SystemEntity.QueueItem]: inject(QueueitemIdActionsApiService),
        [SystemEntity.QueueStatus]: inject(QueuestatusIdActionsApiService),
        [SystemEntity.RecentRecord]: this.noApiServiceFallback(
            SystemEntity.RecentRecord,
        ),
        [SystemEntity.Region]: inject(RegionIdActionsApiService),
        [SystemEntity.Relationship]: inject(RelationshipIdActionsApiService),
        [SystemEntity.Reminder]: this.noApiServiceFallback(
            SystemEntity.Reminder,
        ),
        [SystemEntity.Report]: inject(ReportIdActionsApiService),
        [SystemEntity.ReportRequest]: inject(ReportrequestIdActionsApiService),
        [SystemEntity.RiskLevel]: inject(RisklevelIdActionsApiService),
        [SystemEntity.RiskProfileAnswer]: inject(
            RiskprofileanswerIdActionsApiService,
        ),
        [SystemEntity.RiskProfileQuestion]: inject(
            RiskprofilequestionIdActionsApiService,
        ),
        [SystemEntity.RoleSubType]: inject(RolesubtypeIdActionsApiService),
        [SystemEntity.RoleType]: inject(RoletypeIdActionsApiService),
        [SystemEntity.Salutation]: inject(SalutationIdActionsApiService),
        [SystemEntity.ScheduledJob]: inject(ScheduledjobIdActionsApiService),
        [SystemEntity.ServiceType]: inject(ServicetypeIdActionsApiService),
        [SystemEntity.Session]: inject(SessionIdActionsApiService),
        [SystemEntity.Signatory]: inject(SignatoryIdActionsApiService),
        [SystemEntity.SocialAddress]: inject(SocialaddressIdActionsApiService),
        [SystemEntity.StockBrokingAccount]: this.noApiServiceFallback(
            SystemEntity.StockBrokingAccount,
        ),
        [SystemEntity.SystemLog]: inject(SystemlogIdActionsApiService),
        [SystemEntity.Tag]: inject(TagIdActionsApiService),
        [SystemEntity.Task]: inject(TaskIdActionsApiService),
        [SystemEntity.Team]: inject(TeamIdActionsApiService),
        [SystemEntity.TeamMember]: this.noApiServiceFallback(
            SystemEntity.TeamMember,
        ),
        [SystemEntity.TimeBooking]: inject(TimebookingIdActionsApiService),
        [SystemEntity.Transaction]: inject(TransactionIdActionsApiService),
        [SystemEntity.TransactionEvidence]: inject(
            TransactionevidenceIdActionsApiService,
        ),
        [SystemEntity.Unit]: inject(UnitIdActionsApiService),
        [SystemEntity.UnitGroup]: inject(UnitgroupIdActionsApiService),
        [SystemEntity.User]: inject(UserIdActionsApiService),
        [SystemEntity.UserDashboard]: this.noApiServiceFallback(
            SystemEntity.UserDashboard,
        ),
        [SystemEntity.UserLogin]: this.noApiServiceFallback(
            SystemEntity.UserLogin,
        ),
        [SystemEntity.UserView]: this.noApiServiceFallback(
            SystemEntity.UserView,
        ),
        [SystemEntity.ViewTile]: this.noApiServiceFallback(
            SystemEntity.ViewTile,
        ),
        [SystemEntity.WealthManagementAccount]: inject(
            WealthmanagementaccountIdActionsApiService,
        ),
        [SystemEntity.WebHook]: inject(WebhookIdActionsApiService),
        [SystemEntity.WebHookLog]: inject(WebhooklogIdActionsApiService),
        [SystemEntity.WorkItem]: inject(WorkitemIdActionsApiService),
        [SystemEntity.Workflow]: inject(WorkflowIdActionsApiService),
        [SystemEntity.WorkflowLog]: inject(WorkflowlogIdActionsApiService),
    };

    get(entityType: SystemEntity, id: string): Observable<EntityAction[]> {
        if (!this.serviceMap[entityType]) {
            if (!this.serviceMap[entityType]) {
                return this.noApiServiceFallback(entityType).get(id);
            }
        }
        return this.typedApiService(entityType).get(id);
    }

    hasTypeService(entityType: SystemEntity): boolean {
        return !!this.serviceMap[entityType];
    }

    private typedApiService(entityType: SystemEntity) {
        return this.serviceMap[entityType] as {
            get: (id: string) => Observable<EntityAction[]>;
        };
    }
}
